// removed by extract-text-webpack-plugin
module.exports = {"list":"c-ProductsList__list","loadLessButton":"c-ProductsList__loadLessButton"};